import { render } from "./Form.vue?vue&type=template&id=fb5ad08a&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=fb5ad08a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fb5ad08a"

export default script